var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "button",
    {
      staticClass:
        "button flex justify-center items-center bg-transparent focus:outline-none mb-1 group cursor-pointer",
      attrs: { type: "button" },
      on: { click: _vm.toggleDNUState },
    },
    [
      _c("div", { staticClass: "relative w-6 h-6" }, [
        _c(
          "svg",
          {
            staticClass:
              "lucide lucide-user w-6 h-6 transition-colors duration-200 text-gray-400 group-hover:text-black",
            attrs: {
              xmlns: "http://www.w3.org/2000/svg",
              width: "24",
              height: "24",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "aria-hidden": "true",
            },
          },
          [
            _c("path", {
              attrs: { d: "M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2" },
            }),
            _c("circle", { attrs: { cx: "12", cy: "7", r: "4" } }),
          ]
        ),
        _c(
          "svg",
          {
            class: [
              "lucide lucide-ban absolute inset-0 w-6 h-6 text-red-500 transition-opacity duration-200",
              _vm.currentDNUState
                ? "opacity-100 group-hover:opacity-0"
                : "opacity-0 group-hover:opacity-100",
            ],
            attrs: {
              xmlns: "http://www.w3.org/2000/svg",
              width: "24",
              height: "24",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
              "aria-hidden": "true",
            },
          },
          [
            _c("path", { attrs: { d: "M4.929 4.929 19.07 19.071" } }),
            _c("circle", { attrs: { cx: "12", cy: "12", r: "10" } }),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }